import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32194148&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=32194148&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32194148",
  null
  
)

export default component.exports